<template lang="pug">
  b-modal#configIp(
    ref="configIp"
    :title="$t('ui.ip')"
    centered
    no-fade
    no-close-on-backdrop
    hide-footer
    :busy="loading"
    size="md"
    @hide="hide"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.account_id") }}
        DebounceInput(
          type="text"
          ref="account_id"
          :placeholder='$t("ui.account_id")'
          :value="accountId.toUpperCase()"
          readonly
        )
      .form-group
        label {{ $t("ui.ip") }}
        b-row
          .col-sm-12.col-md-8.col-lg-9.col-xl-9
            DebounceInput(
              type="text"
              ref="newIp"
              :dirty="$v.newIp.$dirty"
              :error="$v.newIp.$error"
              v-model.trim.lazy="$v.newIp.$model"
              :disabled="loading"
            )
            small.text-muted.mr-2 {{ $t("message.allow_to_add_multiple_ip") }}
          .col-sm-12.col-md-4.col-lg-3.col-xl-3.text-right
            SubmitButton(:loading="loading" icon="fa fa-plus" :text="$t('ui.add_ip')" isModal=false type="button" @click="addIp" variant="warning")
        ValidateResult(:value="$v.newIp" :name="$t('ui.ip')")
      .form-group
        label {{ $t("ui.whitelisted_ip") }}
        b-table#tblList.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :items="comIpList" :fields="fields" thead-class="grey")
          template(v-slot:cell(index)="row")
            span {{ row.index + 1 }}
          template(v-slot:cell(ip)="row")
            span #[b {{ row.item }}]
          template(v-slot:cell(action)="row")
            div.d-flex.flex-nowrap(style="justify-content: center;")
              span
                a.fas.fa-lg.fa-fw.fa-trash.text-danger(
                  @click="deleteIp(row.item)"
                  :title="$t('ui.edit')"
                  style="cursor: pointer;"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    //- div(slot="modal-ok")
    //-   SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, minValue, maxValue, minLength, maxLength, email, numeric, url, alphaNum, ipAddress } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    accountId: "",
    ipArr: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      loading: false,
      newIp: "",
      newIpArr: [],
      finalIpArr: [],
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    newIp: {
      required,
      isIpStr(value) {
        let regex = /^[0-9.,]+$/
        if(regex.test(value)) {
          return true
        } else {
          return false
        }
      },
    }
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
        {
          key: "ip",
          label: this.$t("ui.ip"),
          class: "align-middle",
          thClass: "bg-grey"
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
      ]
    },
    comIpList() {
      return this.newIpArr
    }
  },
  mounted: function() {},
  methods: {
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true

        this.$swal({
          title: this.$t("ui.ip"),
          text: this.$t("message.add_ip_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateIp();
          } else {
            this.loading = false
          }
        });
      }
    },
    addIp: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.ip"),
          text: this.$t("message.add_ip_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            let tempArr = this.newIp.split(',').filter(function (x) { return x.toString().trim() != ''})
            let b = [];
            let a = [];
            if (tempArr.length > 0) {
              for (var i = 0; i < tempArr.length; i++) {
                let index = this.newIpArr.indexOf(tempArr[i].trim())
                if (index > -1) {
                  this.loading = false
                  this.$swal(this.$t("ui.fail"), this.$t("message.ip_exists"), "error")
                  return;
                }
                else {
                  if (a.indexOf(tempArr[i].trim()) == -1)
                    a.push(tempArr[i].trim())
                }
              }

              b = this.newIpArr.concat(a)

              this.updateIp(b)
            }
            else {
              this.$swal(this.$t("ui.fail"), this.$t("message.ip_required"), "error")
            }
          } else if (
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.add_ip_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    deleteIp: function(ip) {
      this.loading = true
      this.$swal({
        title: this.$t("ui.ip"),
        text: this.$t("message.delete_ip_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let a = this.newIpArr
          let index = a.indexOf(ip)
          if (index > -1) {
            a.splice(index, 1)
            this.updateIp(a)
          }
          else {
            this.loading = false
            this.$swal(this.$t("ui.fail"), this.$t("message.ip_not_exists"), "error");
            return;
          }

        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.delete_ip_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.cancel();
            }
          });
        }
      });
    },
    updateIp: function(arr) {
      let account_id = this.accountId
      let ip = arr.toString()

      this.$store
        .dispatch("user/updateIp", { account_id, ip })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_ip_whitelist_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel(arr);
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:updateIp", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.newIp = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset();
        this.newIpArr = this.ipArr
        this.finalIpArr = this.ipArr
      });
    },
    done: function() {
      this.$refs.configIp.hide();
      this.$emit("clicked")
    },
    hide: function() {
      this.$refs.configIp.hide();
      this.$emit("clicked")
    },
    cancel: function(arr) {
      this.newIp = ""
      this.newIpArr = arr
      this.$nextTick(() => {
        this.$v.$reset();

      });
    }
  }
}
</script>
